module.exports = __webpack_public_path__ + "static/the-magic-of-thinking-big-f35573eae91c8da002ce50fd62f0ae1a.jpg";